import React from 'react';
import { ComponentWrapper } from 'app/src/components/ComponentWrapper';

import { forTemplate } from 'app/common/lib/util/i18n';
const format = forTemplate('dropbox_attachment');

import Confirm from 'app/scripts/views/lib/confirm.coffee';

interface AttachmentEditPopoverProps {
  onRemoveAttachment: () => void;
}

export const AttachmentEditPopover: React.FunctionComponent<AttachmentEditPopoverProps> = ({
  onRemoveAttachment,
}) => {
  const confirmRemove = () => {
    Confirm.pushView('remove attachment', {
      confirmBtnClass: 'negate',
      fxConfirm: onRemoveAttachment,
    });
  };

  return (
    <ComponentWrapper key="edit-attachment">
      <ul className="pop-over-list">
        <li>
          <a onClick={confirmRemove} role="button">
            {format('remove')}
          </a>
        </li>
      </ul>
    </ComponentWrapper>
  );
};
